/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-else-return */
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { format, subHours, parse } from 'date-fns';
import { getBusBookingDetailsApi } from '../../../api/busApi';
import { getUserDetails } from '../../../api/profileApi';
import { emailFlightOptions } from '../../../api/flightApi';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import {
  getObjectFromLS,
  getValueFromAppConfig,
  getUserAgentId,
  getStringFromLS,
} from '../../../shared/helper-utils/localStorage';
import {
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  checkValidEmailAddress,
} from '../../../shared/constants/Constants';
import '../../hotels/booking-details/BookingDetails.scss';
import {
  formatCurrency,
  formatDate,
  formatTimeString,
  getNewDate,
  hideHeaderFooter,
  isEmpty,
  showHeaderFooter,
} from '../../../shared/helper-utils/appUtils';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppModal from '../../../shared/components/app-modal/AppModal';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import {
  APP_LOGO_URL,
  APP_USER_PROFILE,
} from '../../../saas/AppStorageStaticNames';

const seatTypeDict = {
  ub: 'Upper Berth ',
  lb: 'Lower Berth',
  ss: 'Seater',
};

function BusBookingVoucherPage() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [hasTicket, setHasTicket] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const busInvoiceRef = useRef({});
  const busPaxRef = useRef([]);
  const [agent, setAgent] = useState(undefined);
  const [cancellationRules, setCancellationRules] = useState([]);
  const [showAgency, setShowAgency] = useState(true);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [toEmail, setToEmail] = useState('');

  const getBusBookingDetails = async () => {
    setIsLoading(true);
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const res = await getUserDetails(userProfile.agentId);
    if (res.ApiStatus?.Status === 'OK') {
      if (res.ApiStatus?.Result !== '') {
        const { User } = res.ApiStatus.Result;
        setAgent(User);
      }
    }
    const response = await getBusBookingDetailsApi(transactionId);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.BusInvoice || {};
      busInvoiceRef.current = data;
      if (data.BusPassengers && data.BusPassengers.BusPassenger) {
        data.BusPassengers.BusPassenger = Array.isArray(
          data.BusPassengers.BusPassenger,
        )
          ? data.BusPassengers.BusPassenger
          : [data.BusPassengers.BusPassenger];
        busPaxRef.current = data.BusPassengers.BusPassenger;
        const journeyDate = data.DateOfJourney.split(' ')[0];
        const JourneyDepTime = data.DepTime;
        const cancellations =
          !isEmpty(data.CanxPolicy) && data.CanxPolicy !== '-'
            ? data.CanxPolicy.split(';')
            : [];
        setCancellationRules(cancellations);
      } else {
        data.BusPassengers = { BusPassenger: [] };
        data.BusPassengers.BusPassenger = [
          {
            Title: data.PaxSalutation,
            FirstName: data.PaxFirstName,
            LastName: data.PaxLastName,
            SeatNumber: data.SeatsSelected,
            Age: data.PaxAge,
            Gender: data.PaxGender,
            Status: data.TicketStatus,
          },
        ];
      }

      setHasTicket(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Bookings Details',
        description: response?.Root?.Message,
      });
      setHasTicket(false);
    }
    setIsLoading(false);
  };

  const getTime = (time) => {
    return `${Math.floor(time / 60)}:${time % 60}`;
  };

  const getBpDetails = (str) => {
    const strArr = str.split('##');
    return `${strArr[0]}, ${getTime(strArr[1])}, ${strArr[2]}, ${strArr[4]}, ${
      strArr[5]
    }`;
  };

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  useEffect(() => {
    getBusBookingDetails();
  }, []);

  const handleSendEmail = async () => {
    const fromName = `${agent?.FirstName} ${agent?.LastName}`;
    const fromEmail = agent?.ContactEmail;
    const htmlContent = document.getElementById('ticketheader').innerHTML;
    if (toEmail === '' || checkValidEmailAddress(toEmail)) {
      setAlert({
        title: 'Email',
        description: 'please enter valid email',
        variant: 'error',
      });
      return false;
    }
    setIsLoading(true);
    const response = await emailFlightOptions(
      fromEmail,
      fromName,
      toEmail,
      htmlContent,
      'Your Bus Booking Details',
    );
    if (response?.Root?.Status === 'OK') {
      setShowEmailModal(false);
      setToEmail('');
      setAlert({
        title: 'Email',
        description: 'Email Sent Successfully',
        variant: 'success',
      });
    } else {
      setAlert({
        title: 'Email',
        description: 'Failed to send Email Please try again',
        variant: 'error ',
      });
    }
    setIsLoading(false);
  };

  return (
    <section style={{ backgroundColor: '#fff' }}>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {hasTicket !== undefined && hasTicket && (
        <>
          <section className="print-links d-flex flex-column hide-in-print">
            <div className="hide-in-print d-flex gap-2 flex-column">
              {/* <AppButton
                btnText={showAgency ? 'Hide Agency' : 'Show Agency'}
                variant="green"
                onClick={() => setShowAgency(!showAgency)}
              /> */}
              <AppButton
                btnText="Print"
                variant="green"
                onClick={() => window.print()}
              />
              <AppButton
                btnText="Email"
                variant="green"
                onClick={() => setShowEmailModal(true)}
              />
              <AppButton
                variant="green"
                btnText="Home"
                onClick={() =>
                  window.open(`${window.location.origin}/`, '_blank')
                }
              />
            </div>
          </section>
          <div
            style={{
              padding: '1rem 10px',
              width: '860px',
              marginInline: 'auto',
            }}
            id="ticketheader"
          >
            <div
              style={{
                border: '1px solid #000',
              }}
            >
              <div
                style={{
                  textAlign: 'center',
                  fontWeight: '600',
                  borderBottom: '1px solid #000',
                }}
              >
                <span>Electronic Ticket Receipt</span>
              </div>
              {showAgency && (
                <div
                  style={{
                    padding: '8px',
                  }}
                >
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td>
                          {agent && Object.keys(agent).length > 0 && (
                            <table
                              style={{
                                fontSize: '12px',
                                fontWeight: '500',
                                lineHeight: '16px',
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      color: 'red',
                                      fontWeight: '600',
                                    }}
                                  >
                                    <span>{agent.Company}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>{agent.Address1}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {`${agent.City}, ${agent.State}-${agent.PinCode}, ${agent.Country}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Phone Number : {agent.MobileNumber}</td>
                                </tr>

                                <tr>
                                  <td>Email Id : {agent.ContactEmail}</td>
                                </tr>
                              </tbody>
                            </table>
                          )}
                        </td>
                        <td>
                          <div style={{ float: 'right' }}>
                            <img
                              src={`${
                                appConfig?.appMainUrl
                              }printlogos/${getUserAgentId()}.gif`}
                              onError={(e) =>
                                (e.target.src = getStringFromLS(APP_LOGO_URL))
                              }
                              alt={getUserAgentId()}
                              width="100px"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              <div
                style={{
                  borderBottom: '2px solid #000',
                  marginBottom: '16px',
                }}
              >
                <table width="100%">
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: '100%',
                          paddingLeft: '1rem',
                          fontSize: '14px',
                          fontWeight: '600',
                          textTransform: 'uppercase',
                          textAlign: 'center',
                        }}
                      >
                        Reservation {busInvoiceRef.current.TicketStatus}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <table
                  style={{
                    width: '100%',
                    fontSize: '13px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                >
                  <thead
                    style={{
                      fontWeight: '400',
                      fontSize: '12px',
                    }}
                  >
                    <tr>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        Booking Reference ID
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        Operator PNR
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        Ticket Number{' '}
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        Tentative Reference No
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        DATE OF BOOKING
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        {busInvoiceRef.current.Txid}
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        {busInvoiceRef.current.OperatorPnr}
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        {busInvoiceRef.current.SupplierTicketNumber}
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        {busInvoiceRef.current.TentativeReferenceNo}
                      </td>
                      <td style={{ border: '1px solid #000', padding: '3px' }}>
                        {busInvoiceRef.current.TxDate}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <table
                  style={{
                    width: '100%',
                    fontSize: '13px',
                    textAlign: 'center',
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontSize: '12px',
                          padding: '3px',
                          width: '25%',
                        }}
                      >
                        Operator
                      </td>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontSize: '12px',
                          padding: '3px',
                          width: '25%',
                        }}
                      >
                        Bus Type
                      </td>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontSize: '12px',
                          padding: '3px',
                          width: '25%',
                        }}
                      >
                        ORIGIN / DEPARTURE DATE
                      </td>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontSize: '12px',
                          padding: '3px',
                          width: '25%',
                        }}
                      >
                        DESTINATION / ARRIVAL DATE
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontWeight: '600',
                          padding: '3px',
                        }}
                      >
                        {busInvoiceRef.current.TravelsName}
                      </td>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontWeight: '600',
                          padding: '3px',
                        }}
                      >
                        {busInvoiceRef.current.BusType}
                      </td>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontWeight: '600',
                          padding: '3px',
                        }}
                      >
                        <span style={{ display: 'block' }}>
                          {busInvoiceRef.current.SourceName}
                        </span>
                        <span style={{ display: 'block' }}>
                          {formatTimeString(busInvoiceRef.current.DepTime)}
                        </span>
                        <span style={{ display: 'block' }}>
                          {formatDate(
                            getNewDate(
                              busInvoiceRef.current.DateOfJourney.split(' ')[0],
                            ),
                            DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </span>
                      </td>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontWeight: '600',
                          padding: '3px',
                        }}
                      >
                        <span style={{ display: 'block' }}>
                          {busInvoiceRef.current.DestinationName}
                        </span>
                        <span style={{ display: 'block' }}>
                          {formatTimeString(busInvoiceRef.current.ArrTime)}
                        </span>
                        <span style={{ display: 'block' }}>
                          {busInvoiceRef.current.ArrivalDate !== '' && (
                            <span style={{ display: 'block' }}>
                              {formatDate(
                                getNewDate(busInvoiceRef.current.ArrivalDate),
                                DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                              )}
                            </span>
                          )}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {busPaxRef.current.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <table
                    style={{
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    <thead style={{ fontSize: '12px' }}>
                      <tr>
                        <td
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          Guest Name
                        </td>
                        <td
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          Gender
                        </td>
                        <td
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          Age
                        </td>
                        <td
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          Seat no
                        </td>
                        <td
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          Seat Type
                        </td>
                        <td
                          style={{
                            border: '1px solid #000',
                            padding: '3px',
                            width: '90px',
                          }}
                        >
                          Contact No
                        </td>
                        <td
                          style={{
                            border: '1px solid #000',
                            width: '80px',
                            padding: '3px',
                          }}
                        >
                          Status
                        </td>
                        {/* <td
                          style={{
                            border: '1px solid #000',
                            width: '80px',
                            padding: '3px',
                          }}
                        >
                          Ticket Cost
                        </td> */}
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: '14px', fontWeight: '600' }}>
                      {busPaxRef.current.map((pax, index) => (
                        <tr
                          key={`${pax.Title}-${pax.FirstName}-${pax.LastName}`}
                        >
                          <td
                            style={{
                              border: '1px solid #000',
                              padding: '3px',
                              textTransform: 'uppercase',
                            }}
                          >
                            {`${pax.Title} ${pax.FirstName} ${pax.LastName}`}
                          </td>
                          <td
                            style={{
                              border: '1px solid #000',
                              textTransform: 'capitalize',
                              padding: '3px',
                            }}
                          >
                            {pax.Gender}
                          </td>
                          <td
                            style={{ border: '1px solid #000', padding: '3px' }}
                          >
                            {pax.Age}
                          </td>
                          <td
                            style={{ border: '1px solid #000', padding: '3px' }}
                          >
                            {pax.SeatNumber ? pax.SeatNumber : '-'}
                          </td>
                          <td
                            style={{ border: '1px solid #000', padding: '3px' }}
                          >
                            {pax.SeatType
                              ? seatTypeDict[pax.SeatType.toLowerCase()]
                              : '-'}
                          </td>
                          <td style={{ padding: '3px' }}>
                            {index === 0 ? busInvoiceRef.current.PaxMobile : ''}
                          </td>
                          <td
                            style={{ border: '1px solid #000', padding: '3px' }}
                          >
                            {pax.Status}
                          </td>
                          {/* <td
                            style={{ border: '1px solid #000', padding: '3px' }}
                          >
                            {pax.SeatPrice}
                          </td> */}
                        </tr>
                      ))}
                      <tr>
                        <td
                          style={{
                            border: '1px solid #000',
                            color: '#d31313',
                            padding: '3px',
                          }}
                          colSpan="4"
                        >
                          *Reporting Time : - Passengers are requested to arrive
                          at the boarding point at least 15min. before the
                          scheduled time of departure
                        </td>
                        <td
                          colSpan="2"
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          Amount Paid
                        </td>
                        <td
                          style={{ border: '1px solid #000', padding: '3px' }}
                        >
                          {formatCurrency(
                            Number(busInvoiceRef.current.FareQuoteTotal) +
                              Number(busInvoiceRef.current.AdditionalMarkup),
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              <div style={{ marginBottom: '16px' }}>
                <table
                  style={{
                    width: '100%',
                    fontSize: '13px',
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontWeight: '600',
                          textAlign: 'center',
                          padding: '5px',
                        }}
                      >
                        Boarding Point Details
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #000', padding: '5px' }}>
                        <div>
                          <b>Location:</b> {busInvoiceRef.current.SourceName}
                          {/* {busInvoiceRef.current.BpDetails.split('##')[4]} */}
                        </div>
                        <div>
                          <b>Landmark:</b>{' '}
                          {busInvoiceRef.current.BoardingPointName}
                          {/* {busInvoiceRef.current.BpDetails.split('##')[3]} */}
                        </div>
                        <div>
                          <b>Address:</b>{' '}
                          {/* {busInvoiceRef.current.BpDetails.split('##')[5]} */}
                        </div>
                        <div>
                          <b>Contact:</b>{' '}
                          {/* {busInvoiceRef.current.BpDetails.split('##')[2]} */}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* {busInvoiceRef.current.DpDetails && ( */}
              <div style={{ marginBottom: '16px' }}>
                <table
                  style={{
                    width: '100%',
                    fontSize: '13px',
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: '1px solid #000',
                          fontWeight: '600',
                          textAlign: 'center',
                          padding: '5px',
                        }}
                      >
                        Dropping Point Details
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #000', padding: '5px' }}>
                        <div>
                          <b>Location:</b>{' '}
                          {busInvoiceRef.current.DestinationName}
                          {/* {busInvoiceRef.current.BpDetails.split('##')[4]} */}
                        </div>
                        <div>
                          <b>Landmark:</b>{' '}
                          {busInvoiceRef.current.DroppingPointName}
                          {/* {busInvoiceRef.current.BpDetails.split('##')[3]} */}
                        </div>
                        <div>
                          <b>Address:</b> N/A
                          {/* {busInvoiceRef.current.BpDetails.split('##')[5]} */}
                        </div>
                        <div>
                          <b>Contact:</b> N/A
                          {/* {busInvoiceRef.current.BpDetails.split('##')[2]} */}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* )} */}
              <div
                style={{
                  textAlign: 'center',
                  padding: '5px',
                  fontSize: '14px',
                  fontWeight: '500',
                  border: '1px solid #000',
                }}
              >
                Thanks For choosing us as your ticket provider. Wish you a happy
                journey
              </div>
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: '600',
                  padding: '5px',
                  marginTop: '10px',
                  border: '1px solid #000',
                }}
              >
                Terms and Conditions
              </div>
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '13px',
                }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid #000', width: '50%' }}>
                        <div
                          style={{
                            borderBottom: '1px solid #000',
                            padding: '5px',
                          }}
                        >
                          Travel Partner is not responsible for any delay or
                          inconvenience during thejourney due to breakdown of
                          the vehicle or other reasons beyond the control of
                          Agent
                        </div>
                        <div
                          style={{
                            padding: '5px',
                          }}
                        >
                          Travel Partner is not responsible for any accidents or
                          loss of passenger belongings
                        </div>
                      </td>
                      <td style={{ border: '1px solid #000', width: '50%' }}>
                        <div
                          style={{
                            borderBottom: '1px solid #000',
                            padding: '5px',
                            fontWeight: '500',
                          }}
                        >
                          Cancellation Policy
                        </div>
                        <div style={{ padding: '5px', minHeight: '88px' }}>
                          {!isEmpty(busInvoiceRef.current.CanxPolicy) &&
                            busInvoiceRef.current.CanxPolicy.split(';').length >
                              0 && (
                              <table>
                                <tbody>
                                  {busInvoiceRef.current.CanxPolicy.split(
                                    ';',
                                  ).map((d, index) => (
                                    <tr key={index}>
                                      <td style={{ textAlign: 'left' }}>{d}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                        </div>
                        {/* <div style={{ padding: '5px', minHeight: '88px' }}>
                          {cancellationRules.length > 0 ? (
                            <table style={{ width: '100%' }}>
                              <tbody>
                                {cancellationRules.map((d, index) => (
                                  <tr key={index}>
                                    <td style={{ textAlign: 'left' }}>
                                      {d.time}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                      {d.rule}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div>-</div>
                          )}
                        </div> */}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  textAlign: 'center',
                  marginTop: '10px',
                }}
              >
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontSize: '12px',
                          border: '1px solid #000',
                          padding: '5px',
                        }}
                        width="50%"
                      >
                        <div style={{ fontSize: '14px', fontWeight: '500' }}>
                          Travel Partner is responsible for
                        </div>
                        <div>
                          1. Issuing a valid ticket(a ticket that will be
                          accepted by the bus operator) for its network of bus
                          operators
                        </div>
                        <div>
                          2. Providing refund and support in the event of
                          cancellation
                        </div>
                        <div>
                          3. providing customer support and information in case
                          of any delays/inconvenience
                        </div>
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                          border: '1px solid #000',
                          padding: '5px',
                        }}
                        width="50%"
                      >
                        <div style={{ fontSize: '14px', fontWeight: '500' }}>
                          Travel Partner is not responsible for
                        </div>
                        <div>
                          1. The bus operators bus not departing/reaching on
                          time
                        </div>
                        <div>2.The bus operators employees being rude</div>
                        <div>
                          3. The bus operators bus seats etc not being up to the
                          customers expectations
                        </div>
                        <div>
                          4. The Bus operators cancelling the trip due to
                          unavoidable reasons
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {showEmailModal && (
            <AppModal
              modalTitle="Email Ticket"
              showCloseButton
              onModalClose={() => setShowEmailModal(false)}
            >
              <div>
                <div className="d-flex gap-2">
                  <AppTextInput
                    onChange={(e) => setToEmail(e.target.value)}
                    value={toEmail}
                    name="toEmail"
                    placeholderText=""
                    label="Email to Send"
                  />
                  <AppButton
                    btnText="Send Email"
                    onClick={handleSendEmail}
                    variant="outlined"
                  />
                </div>
              </div>
            </AppModal>
          )}
        </>
      )}
    </section>
  );
}

export default BusBookingVoucherPage;
